import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  loading: false,
  error: null,
  landingImages: [],
};

const landingSlice = createSlice({
  name: 'offers',
  initialState,
  reducers: {
    loadLangingImagesRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadLangingImagesSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.landingImages = action?.payload?.result;
    },
    loadLangingImagesFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    storeLangingImageRequested(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    storeLangingImageSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.storeLandingImage = action?.payload?.result;
    },
    storeLangingImageFail(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },
    deleteLangingImageRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    deleteLangingImageSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.deleteLandingImage = action.payload;
    },
    deleteLangingImageFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadLangingImagesRequested,
  loadLangingImagesSuccess,
  loadLangingImagesFail,
  storeLangingImageRequested,
  storeLangingImageSuccess,
  storeLangingImageFail,
  deleteLangingImageRequested,
  deleteLangingImageSuccess,
  deleteLangingImageFail,
} = landingSlice.actions;

export default landingSlice.reducer;
